import React from 'react'
import { Layout } from 'antd'
import styled from '@emotion/styled'
import LoginForm from './LoginForm'

const { Content } = Layout

const Login = () => {
  return (
    <Layout>
      <LoginContent>
        <LoginForm />
      </LoginContent>
    </Layout>
  )
}

const LoginContent = styled(Content)`
  margin: 0;
`

export default Login
